import React from "react"
import { Text } from "@blueprintjs/core"
import classNames from "utils/classNames"

const BookingOrderItems = ({ bookings, status }) => {
  return (
    <>
      {bookings?.map(booking => {
        const item = booking?.orderItem?.sellableItem

        return (
          <div key={booking.id} className="vt-card-subtitle mt-1 w-full">
            <div className="flex justify-between">
              <Text ellipsize>{item?.name}</Text>
              <strong
                className={classNames("vt-success", {
                  [`vt-${status?.intent}`]: status?.intent,
                })}
              >
                {booking?.procuredQuantity ?? 0} /{" "}
                {booking?.requiredQuantity ?? 0}{" "}
                <span className="vt-muted">Unt</span>
              </strong>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default BookingOrderItems
